import React from 'react';

import { SidebarFreebetCard } from '../../freebet-card';
import { SidebarTournament } from '../../tournament';
import { SidebarPreLobby } from '../../pre-lobby';
import { SidebarPGWheel } from '../../pg-wheel';
import { SidebarJackpot } from '../../jackpot';
import { SidebarPromo } from '../../promo';

interface SidebarPromotionsSectionProps {
  hasPromo: boolean;
  hasJackpot: boolean;
  hasPGWheel: boolean;
  hasPreLobby: boolean;
  hasFreebet: boolean;
  hasTournament: boolean;
  onClose: () => void;
}

export const SidebarPromotionsSection: React.FC<SidebarPromotionsSectionProps> = ({
  hasPromo,
  hasJackpot,
  hasPGWheel,
  hasPreLobby,
  hasFreebet,
  hasTournament,
  onClose,
}) => {
  return (
    <div className="side-menu-new-content">
      <div className="side-menu-new-content-inner">
        {hasJackpot && <SidebarJackpot onClose={onClose} />}
        {hasPGWheel && <SidebarPGWheel onClose={onClose} />}
        {hasTournament && <SidebarTournament onClose={onClose} />}
        {hasFreebet && <SidebarFreebetCard onClose={onClose} />}
        {hasPromo && <SidebarPromo onClose={onClose} />}
        {hasPreLobby && <SidebarPreLobby onClose={onClose} />}
      </div>
    </div>
  );
};
